import axios from 'axios';
import { CLIENTES } from './types';
import { changeLoader } from './loader';
import { setAlert } from './alert';

const toUrlEncoded = (data = {}) => {
    const params = new URLSearchParams();
    Object.keys(data).forEach((key) => {
        const value = data[key];
        if (value === undefined) {
            return;
        }
        if (value === null) {
            params.append(key, '');
            return;
        }
        params.append(key, String(value));
    });
    return params.toString();
};

export const listarClientes = () => async (dispatch) => {
    try {
        await dispatch(changeLoader(true));
        const res = await axios.get(`${process.env.REACT_APP_API_ROUTE}/clientes/listar`);
        await dispatch({
            type: CLIENTES.LISTAR,
            payload: res.data?.clientes || []
        });
        await dispatch(changeLoader(false));
        return true;
    } catch (error) {
        await dispatch(changeLoader(false));
        await dispatch({ type: CLIENTES.ERROR });
        dispatch(setAlert(error?.response?.data?.msg || 'Error al listar clientes', 'danger'));
        return false;
    }
};

export const limpiarClientes = () => async (dispatch) => {
    dispatch({ type: CLIENTES.LIMPIAR });
};

export const cargarDetallesCliente = (id) => async (dispatch) => {
    const config = {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    };

    const body = toUrlEncoded({ id });

    try {
        await dispatch({ type: CLIENTES.DETALLES_CARGANDO });
        await dispatch(changeLoader(true));
        const res = await axios.post(
            `${process.env.REACT_APP_API_ROUTE}/clientes/detalles`,
            body,
            config
        );
        await dispatch({
            type: CLIENTES.DETALLES,
            payload: res.data?.cliente || null
        });
        await dispatch(changeLoader(false));
        return true;
    } catch (error) {
        await dispatch(changeLoader(false));
        await dispatch({ type: CLIENTES.ERROR });
        dispatch(setAlert(error?.response?.data?.msg || 'Error al consultar detalles del cliente', 'danger'));
        return false;
    }
};

export const limpiarDetallesCliente = () => async (dispatch) => {
    dispatch({ type: CLIENTES.LIMPIAR_DETALLES });
};

export const crearCliente = ({ nombre, correo, telefono, rfc }) => async (dispatch) => {
    const config = {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    };

    const body = toUrlEncoded({
        nombre: nombre || '',
        correo: correo || '',
        telefono: telefono || '',
        rfc: rfc || ''
    });

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(
            `${process.env.REACT_APP_API_ROUTE}/clientes/crear`,
            body,
            config
        );

        await dispatch(changeLoader(false));

        if (!res.data?.success) {
            dispatch(setAlert(res.data?.msg || 'No se pudo crear el cliente', 'danger'));
            return false;
        }

        dispatch(setAlert(res.data?.msg || 'Cliente creado correctamente', 'success'));
        await dispatch(listarClientes());
        return true;
    } catch (error) {
        await dispatch(changeLoader(false));
        await dispatch({ type: CLIENTES.ERROR });
        dispatch(setAlert(error?.response?.data?.msg || 'Error al crear cliente', 'danger'));
        return false;
    }
};

export const editarCliente = ({ id, nombre, correo, telefono, rfc }) => async (dispatch) => {
    const config = {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    };

    const body = toUrlEncoded({
        id,
        nombre: nombre || '',
        correo: correo || '',
        telefono: telefono || '',
        rfc: rfc || ''
    });

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(
            `${process.env.REACT_APP_API_ROUTE}/clientes/editar`,
            body,
            config
        );

        await dispatch(changeLoader(false));

        if (!res.data?.success) {
            dispatch(setAlert(res.data?.msg || 'No se pudo editar el cliente', 'danger'));
            return false;
        }

        dispatch(setAlert(res.data?.msg || 'Cliente editado correctamente', 'success'));
        await dispatch(listarClientes());
        await dispatch(limpiarDetallesCliente());
        return true;
    } catch (error) {
        await dispatch(changeLoader(false));
        await dispatch({ type: CLIENTES.ERROR });
        dispatch(setAlert(error?.response?.data?.msg || 'Error al editar cliente', 'danger'));
        return false;
    }
};

export const eliminarCliente = (id) => async (dispatch) => {
    const config = {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    };

    const body = toUrlEncoded({ id });

    try {
        await dispatch(changeLoader(true));
        const res = await axios.post(
            `${process.env.REACT_APP_API_ROUTE}/clientes/eliminar`,
            body,
            config
        );

        await dispatch(changeLoader(false));

        if (!res.data?.success) {
            dispatch(setAlert(res.data?.msg || 'No se pudo eliminar el cliente', 'danger'));
            return false;
        }

        dispatch(setAlert(res.data?.msg || 'Cliente eliminado correctamente', 'success'));
        await dispatch(listarClientes());
        return true;
    } catch (error) {
        await dispatch(changeLoader(false));
        await dispatch({ type: CLIENTES.ERROR });
        dispatch(setAlert(error?.response?.data?.msg || 'Error al eliminar cliente', 'danger'));
        return false;
    }
};
